import { render, staticRenderFns } from "./RbVirtualListChunk.vue?vue&type=template&id=09bd49e8"
import script from "./RbVirtualListChunk.vue?vue&type=script&lang=js"
export * from "./RbVirtualListChunk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports